import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
export default class PaymentService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination, group }) {
    const url = `/v1/companies/${companyUuid}/payments`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination,
      group
    });
    return await this.get(resourceRoute);
  }

  async update(companyUuid, uuid, params) {
    return await super.update(
      `/v1/companies/${companyUuid}/payments/${uuid}`,
      params
    );
  }

  async sendEmailReport(companyUuid, { email, filters, order }) {
    const url = `/v1/companies/${companyUuid}/payments/mail`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(
      url,
      { filters, order },
      [`email=${email}`]
    );
    return await this.post(resourceRoute);
  }
}



// WEBPACK FOOTER //
// ./src/core/service/payment.service.js